// @ts-strict-ignore
// import SearchInput from "@dashboard/components/AppLayout/ListFilters/components/SearchInput";
import { TopNav } from "@dashboard/components/AppLayout/TopNav";
import { DashboardCard } from "@dashboard/components/Card";
import { GetVendorQuotesQuery } from "@dashboard/graphql";
import {
  // GetQuotationCheckoutDetailsQuery,
  useGetQuotationCheckoutDetailsLazyQuery,
} from "@dashboard/graphql";
import { sectionNames } from "@dashboard/intl";
import { QuotationListUrlQueryParams, QuotationListUrlSortField } from "@dashboard/quotations/urls";
import { PageListProps, RelayToFlat, SearchPageProps, SortPage } from "@dashboard/types";
import { ListPageLayout } from "@dashboard/components/Layouts";
import React from "react";
import { useIntl } from "react-intl";
import { QuotationList } from "../QuotationList/QuotationList";
// import { Box } from "@material-ui/core";
import QuotationDetailsDialog from "../QuotationDetailsDialog";

export interface QuotationListPageProps
  extends PageListProps,
    SearchPageProps,
    SortPage<QuotationListUrlSortField> {
  quotations: RelayToFlat<GetVendorQuotesQuery["quotations"]>;
  params: QuotationListUrlQueryParams;
  onView: (id: string) => void;
}

const QuotationListPage = ({
  initialSearch,
  onSearchChange,
  params,
  ...listProps
}: QuotationListPageProps) => {
  const intl = useIntl();
  const [isDetailsOpen, setDetailsOpen] = React.useState(false);
  const [fetchCheckoutDetails, { data: checkoutDetails, loading: checkoutLoading }] =
    useGetQuotationCheckoutDetailsLazyQuery();

  const handleView = (token?: string | null) => {
    if (!token) {
      return;
    }
    setDetailsOpen(true);
    fetchCheckoutDetails({ variables: { token } });
  };

  const handleCloseDetails = () => setDetailsOpen(false);

  return (
    <ListPageLayout>
      <TopNav
        title={intl.formatMessage(sectionNames.quotations)}
        withoutBorder
        isAlignToRight={false}
      />
      <DashboardCard>
        {/* <Box display="flex" alignItems="center" gap={4} paddingBottom={2} paddingX={6}>
          <Box width="320px">
            <SearchInput
              initialSearch={initialSearch}
              placeholder={intl.formatMessage({
                id: "searchQuotations",
                defaultMessage: "Search Quotations...",
              })}
              onSearchChange={onSearchChange}
            />
          </Box>
        </Box> */}
        <QuotationList {...listProps} onView={handleView} />
      </DashboardCard>
      <QuotationDetailsDialog
        open={isDetailsOpen}
        loading={checkoutLoading}
        checkout={checkoutDetails?.checkout ?? null}
        onClose={handleCloseDetails}
      />
    </ListPageLayout>
  );
};

QuotationListPage.displayName = "QuotationListPage";
export default QuotationListPage;
